import { render } from "./CasesProfitChart.vue?vue&type=template&id=78cb1112"
import script from "./CasesProfitChart.vue?vue&type=script&lang=js"
export * from "./CasesProfitChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__